
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
name: "solution_logs",
components: {XInput, Cell, Group, Selector, XButton},
data() {
return {
type: '',
value: '',
solutionData: [],
typeList: [
{key: 'ftype', value: '故障类型'},
{key: 'fdesc', value: '故障描述'},
{key: 'solution', value: '日志内容'}
],
header: null,
role: this.$route.params.role | 'EXPT'
}
},
methods: {
search() {
this.$http.get('/api/v1/normalrepairs?type=' + this.type + '&value=' + this.value + '&offset=0&count=10&role=' + this.role, this.header).then(response => {
if (response.data.total === 0) {
this.$vux.alert.show({
title: '',
content: '结果未找到',
})
} else {
this.solutionData = response.data.content
}
})
},
viewSolution(seq) {
if (this.role === 'EXPT') {
this.$http.get('/api/v1/normalrepairs/' + seq + '?role=EXPT&type=detail', this.header).then(response => {
localStorage.setItem('order', JSON.stringify(response.data.detail))
this.$router.push({name: 'makeMemo', params: {iden: 'EXPT', solutionv: 2}})
})
}
}
},
created() {
if (this.role === 'EXPT') {
const unionid = localStorage.getItem('unionid')
this.$http.get('api/v1/wechat/' + unionid).then((res) => {
if (res.data.length !== 0) {
let account = res.data[0].account
localStorage.setItem('account', account)
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account}).then((res) => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
this.header = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}
})
}
})
} else {
this.header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/solution/solution_logs.vue